import {defineStore} from 'pinia'
import api from '@/services/api'
import {useUserStore} from '@/stores/user'

export const useToastsStore = defineStore('toasts', {
    state: () => ({
        items: []
    }),
    actions: {
        async notification(payload) {
            const {title, body, onInterval, closeOnComplete, closeOnDownload} = payload
            const userStore = useUserStore()
            
            const response = await api.post('api/notification', {
                title,
                data: {message: body, percentage: 0},
            })
            
            const notificationId = response.data.id
            const createdBy = userStore.user?.id
            
            this.add({
                title,
                body,
                notificationId,
                disableAutoHide: true,
                percentage: 0,
                createdBy,
                onInterval,
                closeOnComplete,
                closeOnDownload,
            })
            
            return {notificationId}
        },
        
        add(payload) {
            const {
                title,
                body,
                disableAutoHide,
                percentage,
                notificationId,
                colourScheme,
                createdBy,
                onInterval,
                closeOnComplete,
                closeOnDownload
            } = payload
            
            const item = {
                title,
                body,
                disableAutoHide,
                percentage,
                colourScheme,
                createdBy,
                closeOnComplete,
                closeOnDownload,
                intervalId: null
            }
            
            this.items.push(item)
            
            // Extract the reactive proxy from the store array
            const reactiveItem = this.items[this.items.length - 1]
            
            if (notificationId) {
                this.startInterval({notificationId, item: reactiveItem, onInterval})
            }
        },
        
        startInterval({notificationId, item, onInterval}) {
            const intervalId = setInterval(async () => {
                // Find target in store to ensure we mutate the reactive state
                // and avoid memory leaks if the user removes the toast early
                const targetItem = this.items.find(i => i === item)
                
                if (!targetItem) {
                    clearInterval(intervalId)
                    return
                }
                
                try {
                    const response = await api.get(`api/notification/${notificationId}`)
                    const {percentage, message, downloadUrl} = response.data.item.data
                    
                    if (percentage !== undefined) {
                        targetItem.percentage = percentage
                        if (percentage === 100) {
                            clearInterval(intervalId)
                        }
                    }
                    
                    if (message) targetItem.body = message
                    if (downloadUrl) targetItem.downloadUrl = downloadUrl
                    if (onInterval) onInterval()
                } catch (error) {
                    console.error('Failed to fetch notification update:', error)
                    clearInterval(intervalId)
                }
            }, 1000)
            
            item.intervalId = intervalId
        },
        
        remove(item) {
            const index = this.items.indexOf(item)
            if (index !== -1) {
                if (this.items[index].intervalId) {
                    clearInterval(this.items[index].intervalId)
                }
                this.items.splice(index, 1)
            }
        }
    }
})